import { render, staticRenderFns } from "./RecordingTab.vue?vue&type=template&id=36417d9a&scoped=true&"
import script from "./RecordingTab.vue?vue&type=script&lang=js&"
export * from "./RecordingTab.vue?vue&type=script&lang=js&"
import style0 from "./RecordingTab.vue?vue&type=style&index=0&id=36417d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36417d9a",
  null
  
)

export default component.exports